'use client';

import { Button } from '@petsmart-ui/sparky';

import { useDecisions, useMedalliaForm, useMedalliaFormV2 } from '@libs/common-next';

import './medallia-feedback-link.scss';

const LINK_TEXT = 'Feedback';

export function MedalliaFeedbackLink() {
    const isOneTrust = useDecisions('onetrust');

    const buttonConfigLegacy = useMedalliaForm({
        isActive: !isOneTrust,
    });

    const buttonConfigV2 = useMedalliaFormV2({
        isActive: isOneTrust,
    });

    const { formState, onOpen } = isOneTrust ? buttonConfigV2 : buttonConfigLegacy;

    return (
        <Button
            className="medallia-feedback-link"
            aria-label="Open feedback form"
            disabled={formState !== 'ready'}
            onClick={onOpen}
            text={LINK_TEXT}
            type="button"
            variant="link"
        />
    );
}
